$(document).ready(function () {
  
    $(document).on('click', '.scroll-to', function (e) {
        e.preventDefault();
        var offset = 80;
        var id = screen.width > 768 ? $('.section-form').offset().top : $('.section-form').offset().top;
        $('html, body').animate({
            scrollTop: id - offset
        });
    });


    $(".section-form form").validate();
    

    $('.testimonial-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 3, 
      dots: true,
      arrows: false,
      responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ] 

   });


  var targetOffset = jQuery(".section.section-statistics").offset().top;
  var w = jQuery(window).scroll(function() {
     if (w.scrollTop() > targetOffset) { 
       jQuery('.header').addClass('sticky');
       jQuery('.section-footer').addClass('sticky');
     } else { 
       jQuery('.header').removeClass('sticky');
       jQuery('.section-footer').removeClass('sticky');
     } 

  });

 

    $('.plan-select').click( function(event) {
      $('.plan-select').removeClass('selected');
      $('.select-box').removeClass('active'); 
      $(this).closest(".plan-select").addClass("selected"); 
      $(this).closest(".select-box").addClass("active"); 
      $('.plan-select').each(function(){
          if($(this).hasClass('selected')) {
              $(this).html('<h2><i class="fas fa-check-circle text-secondary"></i></h2>')
          } else {
              $(this).html('<h2><i class="fal fa-circle text-muted"></i></h2>')
          }
      });
    })

    $('.fields input').on('input', function(){
        if( ($('#instructor_first_name').hasClass('valid')) && ($('#instructor_last_name').hasClass('valid')) && ($('#instructor_email').hasClass('valid')) && ($('#instructor_password').hasClass('valid'))) {
          $('.instructor .form-fill').attr('src','/instructor_sign_up/img/green-circle-check.svg');
        } else {
          $('.instructor .form-fill').attr('src','/instructor_sign_up/img/circle-up-icon.svg');
        }

        if( ($('#payment_cardname').hasClass('valid')) && ($('#payment_expiry').hasClass('valid'))) {
          $('.payment .form-fill').attr('src','/instructor_sign_up/img/green-circle-check.svg');
        } else {
          $('.payment .form-fill').attr('src','/instructor_sign_up/img/circle-up-icon.svg');
        }
    });
});
 